module.exports = __webpack_public_path__ + "img/B463CAA46E5F41E790A6FCE476AED149.b463caa4.png";